<template>
    <v-flex sm7>
        <v-card flat class="mt-2 mb-3">
            <v-layout :row="$mq !== 'sm'" :column="$mq === 'sm' || $mq === 'xs'" wrap justify-space-between :reverse="$mq === 'sm' || $mq === 'xs'">
                <v-flex xs12 sm6>
                    <div>
                        <div><h4>{{materia.nombreMateria}}</h4></div>
                        <div>{{materia.materia}}</div>
                        <div>{{materia.docente}}</div>
                    </div>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-rating v-model="resultado" large></v-rating>
                </v-flex>
            </v-layout>
        </v-card>
    </v-flex>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'MyRatings',
    props: ['materia', 'value', 'index', 'respuestas'],
    watch: {
      resultado: function (val) {
        let resultado = this.respuestas[this.index]

        if (resultado === undefined) {
          resultado = {}
        }

        Vue.set(resultado, this.materia.materia, val)
        Vue.set(this.respuestas, this.index, resultado)

        this.$emit('update:respuestas', this.respuestas)
      }
    },
    mounted () {
      this.restauraResultado()
    },
    data: () => ({
      resultado: 0
    }),
    methods: {
      restauraResultado () {
        const respuestas = this.respuestas[this.index]

        if (respuestas === undefined) {
          return
        }

        const r = respuestas[this.materia.materia]
        if (r === undefined) {
          return
        }

        this.resultado = r
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MyRatings.vue